module.exports = __webpack_public_path__ + "img/SERVICECOMB.4557429d.png";